import type { CodeCompositionStats } from '../../types/api/metrics';

export type BarSegments = {
  newPct: number;
  existingPct: number;
  reworkPct: number;
  hasData: boolean;
  newLines: number;
  existingLines: number;
  reworkLines: number;
  totalLines: number;
};

export function formatCompositionPercent(ratio: number | null | undefined): string {
  if (ratio == null || Number.isNaN(Number(ratio))) return 'N/A';
  return `${ratio}%`;
}

export function formatLineCount(n: number | null | undefined): string {
  if (n == null || Number.isNaN(Number(n))) return '—';
  return n.toLocaleString();
}

function roundPct(numerator: number, denominator: number): number {
  if (denominator <= 0) return 0;
  return Math.round((numerator / denominator) * 1000) / 10;
}

export function buildBarSegments(composition: CodeCompositionStats | null): BarSegments {
  if (!composition) {
    return {
      newPct: 0,
      existingPct: 0,
      reworkPct: 0,
      hasData: false,
      newLines: 0,
      existingLines: 0,
      reworkLines: 0,
      totalLines: 0,
    };
  }

  const newLines = composition.newFileAdditions ?? 0;
  const existingLines = composition.existingFileAdditions ?? 0;
  const reworkLines = composition.reworkAdditions ?? 0;
  const totalLines = newLines + existingLines + reworkLines;

  if (totalLines <= 0) {
    return {
      newPct: 0,
      existingPct: 0,
      reworkPct: 0,
      hasData: false,
      newLines,
      existingLines,
      reworkLines,
      totalLines: 0,
    };
  }

  return {
    newPct: roundPct(newLines, totalLines),
    existingPct: roundPct(existingLines, totalLines),
    reworkPct: roundPct(reworkLines, totalLines),
    hasData: true,
    newLines,
    existingLines,
    reworkLines,
    totalLines,
  };
}
